/** @format */
import { type ReactNode } from 'react';
import { CustomDropDown } from 'src/components/CustomDropDown/CustomDropDown';
import { GlobeIcon } from 'src/components/icons';

type LanguageSelectItem = {
  key: string;
  label: ReactNode;
};

type LanguageSelectDropdownProps = {
  items?: LanguageSelectItem[];
  selectedKey?: string;
  label?: ReactNode;
  onSelect?: (key: string) => void;
  placement?: 'bottom' | 'bottomRight' | 'bottomLeft' | 'top' | 'topRight' | 'topLeft';
  triggerClassName?: string;
  triggerLabelClassName?: string;
  itemClassName?: string;
  activeItemClassName?: string;
  defaultValue?: string;
  onReset?: (defaultValue: unknown) => void;
  resetAriaLabel?: string;
};

export default function LanguageSelectDropdown({
  items = [],
  selectedKey,
  label,
  onSelect = () => {},
  placement = 'bottomLeft',
  triggerClassName = 'search-page__filter-trigger',
  triggerLabelClassName = 'search-page__filter-trigger-label',
  itemClassName = '',
  activeItemClassName = '',
  defaultValue,
  onReset,
  resetAriaLabel
}: LanguageSelectDropdownProps) {
  return (
    <CustomDropDown
      placement={placement}
      value={selectedKey}
      defaultValue={defaultValue}
      onReset={onReset}
      resetAriaLabel={resetAriaLabel}
      trigger={
        <button type="button" className={triggerClassName}>
          <span className={triggerLabelClassName}>{label}</span>
          <GlobeIcon />
        </button>
      }>
      <ul className="custom-dropdown__menu" role="menu">
        {items.map(item => (
          <li className="custom-dropdown__menu-item" role="none" key={item.key}>
            <button
              type="button"
              role="menuitem"
              className={`${itemClassName}${item.key === selectedKey && activeItemClassName ? ` ${activeItemClassName}` : ''}`.trim()}
              onClick={() => onSelect(item.key)}>
              {item.label}
            </button>
          </li>
        ))}
      </ul>
    </CustomDropDown>
  );
}
